















import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiToolbar from "@/components/common/AsiToolbar.vue";
import AsiBtn from "@/components/common/AsiBtn.vue";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import WeeklyOverview from "@/components/planning/WeeklyOverview.vue";
import {Icon} from "@/helpers/icons";
import {getWeekNumber} from "@/helpers/functions_asi";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {WeeklyOverview, AsiContentContainer, AsiBtn, AsiToolbar}
})
export default class CustomerWeeklyOverview extends Vue {

	private icons = Icon;

	private date: Date = new Date();
	private loading: boolean = false;

	private get title(): string {
		return this.$t('uiTerms.weeklyOverview')
			+ ' - '
			+ this.$t('uiTerms.weekNumber', {num: getWeekNumber(this.date)});
	}

	private get usersCompany(): CompanySimple | null {
		return this.$store.state.user.loggedInUserCompany;
	}

	private today(): void {
		this.date = new Date();
	}

	private prevWeek(): void {
		const date = new Date(this.date);
		date.setDate(date.getDate() - 7);
		this.date = date;
	}

	private nextWeek(): void {
		const date = new Date(this.date);
		date.setDate(date.getDate() + 7);
		this.date = date;
	}

	private loadingChanged(loading: boolean): void {
		this.loading = loading;
	}

}
